import script from "./GlobalMaintenanceGate.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalMaintenanceGate.vue?vue&type=script&setup=true&lang=js"

import "./GlobalMaintenanceGate.vue?vue&type=style&index=0&id=633bebde&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-633bebde"]])

export default __exports__